import React, { Children } from 'react';
const getFallbackDebugMessage = children => {
  const firstChild = Children.toArray(children)?.[0];
  const componentName = firstChild?.type?.displayName || firstChild?.type?.name ||
  // eslint-disable-next-line no-underscore-dangle
  firstChild?._source?.filename || 'Unknown component';
  const debugMessage = `Suspended: ${componentName}`;
  return <div>{debugMessage}</div>;
};
export default getFallbackDebugMessage;